module.exports = __webpack_public_path__ + "img/multiplier.14b3160a.png";